import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useQuery } from 'react-query';
import { PageTitle } from '../../Headings';
import { TitleWrapper } from '../../Headings/common';
import { sendTestNotification } from '../../../services/notification';

function Notifications() {
  const resultToast = useRef<Toast>(null);

  const { isFetching, refetch: sendNotification } = useQuery('sendNotification', sendTestNotification, {
    enabled: false,
    onSuccess: () => {
      resultToast.current?.show({
        severity: 'success',
        summary: 'Test notification',
        detail: 'Test notification has been successfully sent.',
        life: 3000,
      });
    },
    onError: () => {
      resultToast.current?.show({
        severity: 'error',
        summary: 'Test Notification',
        detail: 'An error has occurred while sending notification.',
        life: 3000,
      });
    },
  });

  const invokeConfirmation = () => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Test Notification',
      icon: 'pi pi-send',
      accept: () => sendNotification(),
    });
  };

  return (
    <>
      <Toast ref={resultToast} />
      <ConfirmDialog />
      <TitleWrapper>
        <PageTitle>Notifications</PageTitle>
      </TitleWrapper>
      <div>
        <Button
          label="Send test notification"
          icon="pi pi-send"
          size="small"
          loading={isFetching}
          onClick={invokeConfirmation}
        />
      </div>
    </>
  );
}

export default Notifications;
